import { Box, makeStyles, Tooltip, Typography, useTheme } from '@material-ui/core'
import { Info } from '@material-ui/icons'
import React from 'react'
import { styles } from '../standardCard.styles'

interface StandardCardTooltipProps {
  tooltipTitle?: string
  tooltipCaption?: string
  error?: boolean
  className?: string
  style?: React.CSSProperties
  noIcon?: boolean
}

export const StandardCardTooltip: React.FC<StandardCardTooltipProps> = ({
  tooltipTitle,
  tooltipCaption,
  className,
  style,
  error = false,
  noIcon = false
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const iconColor = error ? 'error' : 'primary'
  const textColor = error ? 'error' : 'textSecondary'

  return (
    <>
      <Box className={`${classes.tooltip} ${className}`} style={style}>
        {!noIcon && (
          <Tooltip title={tooltipTitle || ''} placement="bottom">
            <Info fontSize="small" color={iconColor} className={classes.tooltipIcon} />
          </Tooltip>
        )}
        <Typography variant="subtitle2" color={textColor} className={classes.tooltipCaption}>
          {tooltipCaption}
        </Typography>
      </Box>
    </>
  )
}
